export default "__VITE_ASSET__Ci$m4qPw__"